import type { TestId } from '@repo/test-id';
import { tr } from '@repo/locale';

import PromoCarouselSlide from '@features/promo/components/PromoCarouselSlide';

import goldenWallet from '@assets/images/promo/golden-wallet.webp';
import coin1 from '@assets/images/promo/coin-1.webp';
import coin2 from '@assets/images/promo/coin-2.webp';
import coin3 from '@assets/images/promo/coin-3.webp';

interface Props {
  testId: TestId;
}

export default function EntranceGoldenWalletSlide({ testId }: Props) {
  return (
    <PromoCarouselSlide
      title={tr('promo:entrance.golden_wallet.title')}
      points={[
        { label: tr('promo:entrance.golden_wallet.point_1') },
        { label: tr('promo:entrance.golden_wallet.point_3') },
        { label: tr('promo:entrance.golden_wallet.point_2'), isSoon: true },
      ]}
      testId={testId}
      theme="gold"
    >
      <img src={goldenWallet} alt="" aria-hidden="true" className="absolute top-20 w-60" />
      <img src={coin1} alt="" aria-hidden="true" className="absolute top-14 left-18 size-16" />
      <img src={coin2} alt="" aria-hidden="true" className="absolute top-48 right-20 size-14" />
      <img src={coin3} alt="" aria-hidden="true" className="absolute -bottom-4 left-55 size-12" />
    </PromoCarouselSlide>
  );
}
